import { defineBool } from '@spotify-internal/remote-config-properties';

export const presaveRollout = defineBool({
  name: 'presave-rollout',
  description: 'Rollout feature flag for presave',
  default: false,
});

export const unassociatedMusicVideosRollout = defineBool({
  name: 'unassociated-music-videos-rollout',
  description: 'Rollout feature flag for unassociated music videos tab.',
  default: false,
});

export const unclearedMusicVideosRollout = defineBool({
  name: 'uncleared-music-videos-rollout',
  description:
    'Rollout feature flag for uncleared music videos tab and features.',
  default: false,
});

export const newAvailabilityRollout = defineBool({
  name: 'new-availability',
  description: 'Enable availability from shared capabilities',
  default: false,
});

export const properties = [
  presaveRollout,
  unassociatedMusicVideosRollout,
  unclearedMusicVideosRollout,
  newAvailabilityRollout,
];
